import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c8561bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-between status-line" }
const _hoisted_2 = { class: "row col-2" }
const _hoisted_3 = {
  "data-test": "equipment-tag",
  class: "q-mx-md tag"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "row justify-between items-center content-center" }
const _hoisted_6 = { class: "comment-text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Alert")
const _hoisted_9 = {
  key: 1,
  class: "q-pr-sm last-comments col-2",
  "data-test": "last-comments",
  style: {"text-overflow":"clip"}
}
const _hoisted_10 = {
  key: 2,
  class: "q-pr-sm col-2",
  "data-test": "serial-number"
}
const _hoisted_11 = {
  key: 3,
  class: "q-pr-sm col-3 row",
  "data-test": "kpis-statuses"
}
const _hoisted_12 = { class: "q-pr-md" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Oil ")
const _hoisted_14 = { class: "q-pr-md" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Vibration ")
const _hoisted_16 = { class: "q-pr-md" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Performance ")
const _hoisted_18 = { class: "q-pr-md" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Breakdown voltage ")
const _hoisted_20 = { class: "q-pr-md" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Seals ")
const _hoisted_22 = {
  key: 4,
  class: "col-2 q-pr-sm",
  "data-test": "alert-icon"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "iconContainer" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-my-auto" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "comment-event" }, "Event Comments")
], -1 /* HOISTED */))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_28 = { class: "iconContainer" }
const _hoisted_29 = { class: "iconContainer" }
const _hoisted_30 = { class: "iconContainer" }
const _hoisted_31 = {
  key: 1,
  class: "q-mr-md"
}
const _hoisted_32 = {
  key: 5,
  class: "ml-auto"
}
const _hoisted_33 = {
  class: "row avail-reliability flex-row justify-end",
  "data-test": "availability-reliability"
}
const _hoisted_34 = {
  key: 0,
  class: "q-mr-md q-mt-sm",
  "data-test": "availability-reliability"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "12 months:", -1 /* HOISTED */))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 1,
  class: "q-pr-xs q-mr-sm row items-center content-center"
}
const _hoisted_38 = { class: "column text-center" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "RUN", -1 /* HOISTED */))
const _hoisted_40 = { "data-test": "eq_availability items-center" }
const _hoisted_41 = {
  key: 2,
  class: "q-pr-xs q-mr-sm row items-center content-center"
}
const _hoisted_42 = { class: "column text-center" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "RUN LIMITED", -1 /* HOISTED */))
const _hoisted_44 = { "data-test": "eq_availability" }
const _hoisted_45 = {
  key: 3,
  class: "q-pr-xs q-mr-sm row items-center content-center"
}
const _hoisted_46 = { class: "column text-center" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "ABNR", -1 /* HOISTED */))
const _hoisted_48 = { "data-test": "eq_availability items-center" }
const _hoisted_49 = {
  key: 4,
  class: "q-pr-xs q-mr-sm row items-center content-center"
}
const _hoisted_50 = { class: "column text-center" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "SCH", -1 /* HOISTED */))
const _hoisted_52 = { "data-test": "eq_availability items-center" }
const _hoisted_53 = {
  key: 5,
  class: "q-pr-xs q-mr-sm row items-center content-center"
}
const _hoisted_54 = { class: "column text-center" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "UNSCH", -1 /* HOISTED */))
const _hoisted_56 = {
  class: "text-align-center items-center",
  "data-test": "eq_availability"
}
const _hoisted_57 = {
  key: 6,
  class: "q-pr-xs q-mr-sm row items-center content-center"
}
const _hoisted_58 = { class: "column text-center" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Nbr Trip", -1 /* HOISTED */))
const _hoisted_60 = {
  class: "text-align-center items-center",
  "data-test": "eq_availability"
}
const _hoisted_61 = { class: "q-pr-sm row items-center content-center" }
const _hoisted_62 = { class: "column" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Avail.", -1 /* HOISTED */))
const _hoisted_64 = { "data-test": "eq_availability" }
const _hoisted_65 = { class: "q-pr-sm row items-center content-center" }
const _hoisted_66 = { class: "column" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Reliab.", -1 /* HOISTED */))
const _hoisted_68 = { "data-test": "eq_reliability" }
const _hoisted_69 = {
  key: 7,
  class: "q-mr-sm row"
}
const _hoisted_70 = {
  class: "q-pr-md column",
  style: {"width":"60px"}
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "MTBF", -1 /* HOISTED */))
const _hoisted_72 = { "data-test": "eq_MTBF" }
const _hoisted_73 = {
  class: "q-pr-md column",
  style: {"width":"60px"}
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "MTTR", -1 /* HOISTED */))
const _hoisted_75 = { "data-test": "eq_MTTR" }
const _hoisted_76 = {
  class: "q-pr-md column",
  style: {"width":"80px"}
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "UTILIZATION", -1 /* HOISTED */))
const _hoisted_78 = {
  class: "text-center",
  "data-test": "eq_Utilization"
}
const _hoisted_79 = { class: "col-1" }
const _hoisted_80 = { key: 6 }
const _hoisted_81 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LegendTooltip = _resolveComponent("LegendTooltip")!
  const _component_EquipmentStatusIcon = _resolveComponent("EquipmentStatusIcon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_AlertsIcon = _resolveComponent("AlertsIcon")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EquipmentBarchart = _resolveComponent("EquipmentBarchart")!
  const _directive_close_popup = _resolveDirective("close-popup")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.equipment.tag), 1 /* TEXT */),
        (_ctx.equipment.lastEquipmentStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_LegendTooltip, {
                text: _ctx.equipment.lastEquipmentStatus.status
              }, null, 8 /* PROPS */, ["text"]),
              _createVNode(_component_EquipmentStatusIcon, {
                status: 
              _ctx.equipment.lastEquipmentStatus &&
              _ctx.equipment.lastEquipmentStatus.status
            
              }, null, 8 /* PROPS */, ["status"]),
              _createElementVNode("span", {
                "data-test": "current-status",
                class: _normalizeClass(_ctx.getClass())
              }, _toDisplayString(_ctx.convertEnumToStatus(_ctx.equipment.lastEquipmentStatus.status)), 3 /* TEXT, CLASS */)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      (_ctx.weeklyComments)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.equipment.weeklyReportComments, (comment) => {
            return (_openBlock(), _createElementBlock("div", {
              key: comment,
              class: "last-comments-wrap q-mb-xs col-5"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatDate(comment.date)) + " - " + _toDisplayString(comment.comment), 1 /* TEXT */),
                (comment.isAlert)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_q_tooltip, { class: "text-body2" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_q_icon, {
                        name: "warning",
                        class: "q-mr-sm",
                        size: "xs"
                      })
                    ]))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_q_btn, {
                  outline: "",
                  round: "",
                  class: "main-button-round",
                  icon: "edit",
                  size: "10px",
                  onClick: ($event: any) => (_ctx.onEditComment(comment))
                }, null, 8 /* PROPS */, ["onClick"])
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (_ctx.equipmentListView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.equipment.lastEquipmentComment
            ? _ctx.equipment.lastEquipmentComment.comment
            : ""), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_ctx.equipmentListView && _ctx.showSerialNumber())
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " S/N: " + _toDisplayString(_ctx.equipment.serialNumber ? _ctx.equipment.serialNumber : "unknown") + " since " + _toDisplayString(_ctx.equipment.installationDate ? _ctx.equipment.installationDate : "unknown"), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_ctx.equipmentListView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createVNode(_component_q_icon, {
                class: _normalizeClass(_ctx.getClassQualityIcon(_ctx.equipment.lastOilStatus)),
                name: _ctx.qualityIcon(_ctx.equipment.lastOilStatus)
              }, null, 8 /* PROPS */, ["class", "name"]),
              _hoisted_13
            ], 512 /* NEED_PATCH */), [
              [_vShow, /*equipment.shouldDisplayLubeOil &&*/ _ctx.equipment.lastOilStatus]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_14, [
              _createVNode(_component_q_icon, {
                class: _normalizeClass(_ctx.getClassQualityIcon(_ctx.equipment.lastVibrationStatus)),
                name: _ctx.qualityIcon(_ctx.equipment.lastVibrationStatus)
              }, null, 8 /* PROPS */, ["class", "name"]),
              _hoisted_15
            ], 512 /* NEED_PATCH */), [
              [_vShow, 
            /*equipment.shouldDisplayOfflineVib &&*/ _ctx.equipment.lastVibrationStatus
          ]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_16, [
              _createVNode(_component_q_icon, {
                class: _normalizeClass(_ctx.getClassQualityIcon(_ctx.equipment.lastPerformanceStatus)),
                name: _ctx.qualityIcon(_ctx.equipment.lastPerformanceStatus)
              }, null, 8 /* PROPS */, ["class", "name"]),
              _hoisted_17
            ], 512 /* NEED_PATCH */), [
              [_vShow, 
            /*equipment.shouldDisplayPerf &&*/ _ctx.equipment.lastPerformanceStatus
          ]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_18, [
              _createVNode(_component_q_icon, {
                class: _normalizeClass(_ctx.getClassQualityIcon(_ctx.equipment.lastInsulationStatus)),
                name: _ctx.qualityIcon(_ctx.equipment.lastInsulationStatus)
              }, null, 8 /* PROPS */, ["class", "name"]),
              _hoisted_19
            ], 512 /* NEED_PATCH */), [
              [_vShow, _ctx.equipment.lastInsulationStatus]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_20, [
              _createVNode(_component_q_icon, {
                class: _normalizeClass(_ctx.getClassQualityIcon(_ctx.equipment.worstDryGasSealStatus)),
                name: _ctx.qualityIcon(_ctx.equipment.worstDryGasSealStatus)
              }, null, 8 /* PROPS */, ["class", "name"]),
              _hoisted_21
            ], 512 /* NEED_PATCH */), [
              [_vShow, _ctx.equipment.worstDryGasSealStatus]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.equipmentListView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createCommentVNode(" Event Comments dialog box  "),
                (
                _ctx.equipment.nbOfCommentAlerts && _ctx.equipment.nbOfCommentAlerts > 0
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_q_dialog, {
                        modelValue: _ctx.showTooltip,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showTooltip) = $event)),
                        persistent: "",
                        "max-width": "400px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card, { style: {"width":"600px","max-width":"80vw"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_card_section, { class: "row justify-between q-py-xs" }, {
                                default: _withCtx(() => [
                                  _hoisted_26,
                                  _createVNode(_component_q_card_actions, null, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        icon: "close",
                                        flat: "",
                                        round: "",
                                        dense: ""
                                      }, null, 512 /* NEED_PATCH */), [
                                        [_directive_close_popup]
                                      ])
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_q_card_section, {
                                style: {"max-height":"60vh"},
                                class: "scroll"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_list, {
                                    bordered: "",
                                    separator: ""
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentsData, (alertComment) => {
                                        return _withDirectives((_openBlock(), _createBlock(_component_q_item, { key: alertComment }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(alertComment), 1 /* TEXT */)
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)), [
                                          [_directive_ripple]
                                        ])
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue"])
                    ]))
                  : _createCommentVNode("v-if", true),
                (
                _ctx.equipment.nbOfCommentAlerts && _ctx.equipment.nbOfCommentAlerts > 0
              )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "q-mr-md cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args)))
                    }, [
                      _createVNode(_component_q_btn, {
                        dense: "",
                        round: "",
                        flat: "",
                        icon: "warning",
                        size: "md",
                        class: "icon-button"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_27,
                          (_ctx.equipment.nbOfCommentAlerts > 0)
                            ? (_openBlock(), _createBlock(_component_q_badge, {
                                key: 0,
                                floating: "",
                                transparent: "",
                                rounded: "",
                                label: parseInt(_ctx.equipment.nbOfCommentAlerts),
                                class: "badge"
                              }, null, 8 /* PROPS */, ["label"]))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createCommentVNode(" Aleart Icon "),
              _createElementVNode("div", _hoisted_28, [
                (_ctx.equipment.unreadAlerts && _ctx.equipment.unreadAlerts > 0)
                  ? (_openBlock(), _createBlock(_component_LegendTooltip, {
                      key: 0,
                      text: "alert"
                    }))
                  : _createCommentVNode("v-if", true),
                (_ctx.equipment.unreadAlerts && _ctx.equipment.unreadAlerts > 0)
                  ? (_openBlock(), _createBlock(_component_AlertsIcon, {
                      key: 1,
                      "number-of-unread-alerts": parseInt(_ctx.equipment.unreadAlerts)
                    }, null, 8 /* PROPS */, ["number-of-unread-alerts"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createCommentVNode(" work order Icon  "),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.equipment.hasPendingWOStatus)
                  ? (_openBlock(), _createBlock(_component_LegendTooltip, {
                      key: 0,
                      text: "work_order"
                    }))
                  : _createCommentVNode("v-if", true),
                (_ctx.equipment.hasPendingWOStatus)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      name: "settings_backup_restore",
                      class: "icon-button iconForPendingWO"
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _createCommentVNode(" shopping cart Icon  "),
              _createElementVNode("div", _hoisted_30, [
                (_ctx.equipment.missingStocks && _ctx.equipment.missingStocks > 0)
                  ? (_openBlock(), _createBlock(_component_LegendTooltip, {
                      key: 0,
                      text: "spare_parts"
                    }))
                  : _createCommentVNode("v-if", true),
                (_ctx.equipment.missingStocks && _ctx.equipment.missingStocks > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createVNode(_component_q_btn, {
                        dense: "",
                        round: "",
                        flat: "",
                        icon: "shopping_cart",
                        size: "md",
                        class: "icon-button"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_badge, {
                            floating: "",
                            transparent: "",
                            rounded: "",
                            label: _ctx.equipment.missingStocks,
                            class: "badge"
                          }, null, 8 /* PROPS */, ["label"])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (
          _ctx.reportingView === _ctx.ReportingViewType.WEEKLY ||
          (_ctx.reportingView === _ctx.ReportingViewType.BARCHART && _ctx.equipment.avRe)
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              (_ctx.reportingView === _ctx.ReportingViewType.WEEKLY && _ctx.equipment.avRe)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                : _createCommentVNode("v-if", true),
              (_ctx.reportingView === _ctx.ReportingViewType.BARCHART)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.equipment?.run) + " h ", 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.reportingView === _ctx.ReportingViewType.BARCHART)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.equipment?.runLimited) + " h ", 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.reportingView === _ctx.ReportingViewType.BARCHART)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.equipment?.abnr) + " h ", 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (
              _ctx.reportingView === _ctx.ReportingViewType.WEEKLY ||
              _ctx.ReportingViewType.BARCHART
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.equipment?.sch) + " h ", 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (
              _ctx.reportingView === _ctx.ReportingViewType.WEEKLY ||
              _ctx.ReportingViewType.BARCHART
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.equipment?.unsch) + " h ", 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.reportingView === _ctx.ReportingViewType.BARCHART)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createTextVNode(_toDisplayString(_ctx.equipment?.nbrTrip % 1 !== 0
                    ? _ctx.equipment?.nbrTrip.toFixed(1)
                    : _ctx.equipment?.nbrTrip), 1 /* TEXT */),
                        _createCommentVNode(" ternary operator for decimal value ")
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", {
                class: "q-mr-sm row",
                style: _normalizeStyle([{"border-radius":"6px"}, [
              {
                backgroundColor: _ctx.getBgColor(
                  _ctx.equipment.availability,
                  _ctx.equipment.reliability
                ),
              },
            ]])
              }, [
                _createElementVNode("span", null, [
                  _createVNode(_component_q_chip, {
                    square: "",
                    class: _normalizeClass(["avail-rel-chip", 
                  _ctx.getClassQualityIconForAvlRel(
                    _ctx.equipment.availability,
                    _ctx.equipment.reliability
                  )
                ]),
                    icon: 
                  _ctx.geticonForAvlRel(
                    _ctx.equipment.availability,
                    _ctx.equipment.reliability
                  )
                
                  }, null, 8 /* PROPS */, ["icon", "class"])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    (
                    _ctx.equipment.availability !==
                      _ctx.equipment.previousWeekAvailability &&
                    _ctx.reportingView === _ctx.ReportingViewType.WEEKLY
                  )
                      ? (_openBlock(), _createBlock(_component_q_tooltip, {
                          key: 0,
                          class: "text-body2",
                          anchor: "top middle",
                          self: "bottom middle"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Previous Week availability:" + _toDisplayString(_ctx.formatter(_ctx.equipment.previousWeekAvailability, false)) + "% ", 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _hoisted_63,
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.formatter(_ctx.equipment.availability, false)) + "% ", 1 /* TEXT */)
                  ]),
                  (
                  _ctx.equipment.availability !==
                    _ctx.equipment.previousWeekAvailability &&
                  _ctx.reportingView === _ctx.ReportingViewType.WEEKLY
                )
                    ? (_openBlock(), _createBlock(_component_q_icon, {
                        key: 0,
                        size: "xs",
                        name: 
                  _ctx.iconARType(
                    _ctx.equipment.availability,
                    _ctx.equipment.previousWeekAvailability
                  )
                
                      }, null, 8 /* PROPS */, ["name"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    (
                    _ctx.equipment.availability !==
                      _ctx.equipment.previousWeekAvailability &&
                    _ctx.reportingView === _ctx.ReportingViewType.WEEKLY
                  )
                      ? (_openBlock(), _createBlock(_component_q_tooltip, {
                          key: 0,
                          class: "text-body2",
                          anchor: "top middle",
                          self: "bottom middle"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Previous Week reliability:" + _toDisplayString(_ctx.formatter(_ctx.equipment.previousWeekReliability, false)) + "% ", 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _hoisted_67,
                    _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.formatter(_ctx.equipment.reliability, false)) + "% ", 1 /* TEXT */)
                  ]),
                  (
                  _ctx.equipment.availability !==
                    _ctx.equipment.previousWeekAvailability &&
                  _ctx.reportingView === _ctx.ReportingViewType.WEEKLY
                )
                    ? (_openBlock(), _createBlock(_component_q_icon, {
                        key: 0,
                        size: "xs",
                        name: 
                  _ctx.iconARType(
                    _ctx.equipment.reliability,
                    _ctx.equipment.previousWeekReliability
                  )
                
                      }, null, 8 /* PROPS */, ["name"]))
                    : _createCommentVNode("v-if", true)
                ])
              ], 4 /* STYLE */),
              (_ctx.reportingView === _ctx.ReportingViewType.BARCHART)
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.formatter(_ctx.equipment.MTBF, true)) + " h ", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.formatter(_ctx.equipment.MTTR, true)) + " h ", 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.equipment?.utilizationRatio) + "% ", 1 /* TEXT */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_79, [
        _createVNode(_component_router_link, {
          to: {
            name: 'EquipmentDetails',
            params: {
              id: _ctx.equipment.id,
              equipmentModelName: _ctx.equipment.equipmentModel.name,
              equipmentTag: _ctx.equipment.tag,
              countryBloc: _ctx.getSelectedCountryBloc,
              site: _ctx.getSelectedSite,
            },
          },
          style: {"text-decoration":"none"},
          class: "float-right text-grey-8 q-mr-md"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn, {
              outline: "",
              rounded: "",
              "no-caps": "",
              label: "Details",
              size: "sm",
              class: "main-button"
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"])
      ]),
      (_ctx.reportingView === _ctx.ReportingViewType.BARCHART)
        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
            _createVNode(_component_q_btn, {
              size: "md",
              flat: "",
              class: "red text-weight-bold",
              icon: _ctx.iconType,
              onClick: _ctx.emitExpensionButtonTag
            }, null, 8 /* PROPS */, ["icon", "onClick"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.reportingView === _ctx.ReportingViewType.BARCHART)
      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
          _withDirectives(_createVNode(_component_EquipmentBarchart, { equipment: _ctx.equipment }, null, 8 /* PROPS */, ["equipment"]), [
            [_vShow, _ctx.iconType === 'expand_less']
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}